module.exports = __webpack_public_path__ + "static/media/errorAssignExpert.a6dbe086.svg";